import { render, staticRenderFns } from "./ShopProductBrandTimeList.vue?vue&type=template&id=a1011a22&scoped=true"
import script from "./ShopProductBrandTimeList.vue?vue&type=script&lang=js"
export * from "./ShopProductBrandTimeList.vue?vue&type=script&lang=js"
import style0 from "./ShopProductBrandTimeList.vue?vue&type=style&index=0&id=a1011a22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1011a22",
  null
  
)

export default component.exports